module.exports = __webpack_public_path__ + "pakistan.svg?de424f770cf455bcfa9b12a0ded41488";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/pakistan.svg
// module id = 259
// module chunks = 10